// Localization utility for US/UK English differences

export const LOCALE_TEXT = {
  USD: {
    // Spelling variations
    optimized: 'optimized',
    optimised: 'optimized',
    customized: 'customized',
    customised: 'customized',
    organized: 'organized',
    organised: 'organized',
    canceled: 'canceled',
    cancelled: 'canceled',
    mobile: 'mobile',
    colour: 'color',
    
    // Descriptive text
    mobileOptimized: 'Mobile Optimized',
    conversionOptimized: 'conversion-optimized',
    
    // Contact info
    phoneLabel: 'Phone',
    phoneExample: '+1 (555) 123-4567',
    supportPhone: '1-800-123-4567',
    
    // Business terms
    neighbourhood: 'neighborhood',
    realise: 'realize',
    recognise: 'recognize',
    analyse: 'analyze',
    defence: 'defense',
    licence: 'license',
    practise: 'practice',
    centre: 'center',
    
    // Common phrases
    trialButton: 'Start 14-Day Trial for $5',
    cancelAnytime: 'Cancel anytime',
    
    // Address format
    postalCode: 'ZIP Code',
    postcode: 'ZIP Code',
    
    // Date format
    dateFormat: 'MM/DD/YYYY',
    
    // Currency symbol
    currencySymbol: '$',
    currencyCode: 'USD',
    
    // Country-specific
    country: 'United States',
    language: 'en-US'
  },
  
  GBP: {
    // Spelling variations
    optimized: 'optimised',
    optimised: 'optimised',
    customized: 'customised',
    customised: 'customised',
    organized: 'organised',
    organised: 'organised',
    canceled: 'cancelled',
    cancelled: 'cancelled',
    mobile: 'mobile',
    colour: 'colour',
    
    // Descriptive text
    mobileOptimized: 'Mobile Optimised',
    conversionOptimized: 'conversion-optimised',
    
    // Contact info
    phoneLabel: 'Phone',
    phoneExample: '+44 20 1234 5678',
    supportPhone: '0800 123 4567',
    
    // Business terms
    neighbourhood: 'neighbourhood',
    realise: 'realise',
    recognise: 'recognise',
    analyse: 'analyse',
    defence: 'defence',
    licence: 'licence',
    practise: 'practise',
    centre: 'centre',
    
    // Common phrases
    trialButton: 'Start 14-Day Trial for £5',
    cancelAnytime: 'Cancel anytime',
    
    // Address format
    postalCode: 'Postcode',
    postcode: 'Postcode',
    
    // Date format
    dateFormat: 'DD/MM/YYYY',
    
    // Currency symbol
    currencySymbol: '£',
    currencyCode: 'GBP',
    
    // Country-specific
    country: 'United Kingdom',
    language: 'en-GB'
  }
};

// Hook to get localized text
export const useLocale = (currency = 'USD') => {
  const locale = LOCALE_TEXT[currency] || LOCALE_TEXT.USD;
  
  return {
    t: (key, fallback = '') => locale[key] || fallback,
    locale,
    currency,
    isUK: currency === 'GBP',
    isUS: currency === 'USD'
  };
};

// Helper function to get text without hook
export const getLocaleText = (currency, key, fallback = '') => {
  const locale = LOCALE_TEXT[currency] || LOCALE_TEXT.USD;
  return locale[key] || fallback;
};
